module.exports = __webpack_public_path__ + "media/images/email-388ae074ecc98a37b3177edf2118bf51.png";